import { Pie } from "@ant-design/plots";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { colors } from "../../core/theme";
import UserServices from "../../services/UserServices";

const PieActivePatients = ({ selectedData, onClick, loadingParent }) => {
  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState({
    appendPadding: 10,
    data: null,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.8,
    label: {
      type: "outer",
      offset: 0,
      content: "{value}",
      style: {
        textAlign: "center",
        fontSize: 14,
      },
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: "",
      },
    },
    legend: {
      layout: "horizontal",
      position: "bottom",
    },
    color: [colors.custom_green, colors.custom_red],
  });

  useEffect(() => {
    if (loadingParent === false) {
      getPieActivePatients();
    }
  }, [selectedData, loadingParent]);

  const getPieActivePatients = async () => {
    setLoading(true);
    try {
      const response = await UserServices.getInactiveContacts(
        selectedData.period,
        selectedData.suscription,
        selectedData.enterprise
      );

      if (response.status >= 200 && response.status < 300) {
        setConfig((v) => ({
          ...v,
          data: [
            {
              type: "Activos",
              value: response.data.actives_count,
            },
            {
              type: "Inactivos",
              value: response.data.inactives_count,
            },
          ],
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = (data) => {
    if (onClick) {
      onClick(data);
    }
  };

  return (
    <div className="relative" style={{ minHeight: 318, height: "100%" }}>
      {(loading || config.data === null) && (
        <div
          style={{
            height: 260,
            width: 260,
            borderRadius: 900,
            border: "24px solid lightgray",
            left: "50%",
            transform: "translateX(-50%)",
            position: "absolute",
            top: 20,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 100,
          }}
        >
          <div style={{ color: "lightgray" }}>Cargando</div>
        </div>
      )}
      {config.data !== null && !loading && (
        <Pie
          {...config}
          onEvent={(chart, event) => {
            if (event.type === "click") {
              handleClick(event.data.data);
            }
          }}
        />
      )}
    </div>
  );
};

PieActivePatients.propTypes = {
  selectedData: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  loadingParent: PropTypes.bool.isRequired,
};

export default React.memo(PieActivePatients);
